import React from 'react';
import Row from "@Containers/components/Row";
import usePassengers from "@Hooks/selector/usePassengers";
import {useTranslation} from "@Translation/hooks/useTranslation";
import EuroConversionNotice from "@Currency/components/EuroConversionNotice";
import {getYear} from "date-fns";
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import GroupPrices from "@Route/components/Price/PassengerGroup/GroupPrices";
import PriceWithCurrency from "@Route/components/Price/PriceWithCurrency";
import Translation from "@Translation/components/Translation";

interface PriceDetailsProps {
    route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType,
    totalPrice: number,
}

function PriceDetails({route, totalPrice}: PriceDetailsProps) {
    const {passengers} = usePassengers()
    const totalLabel = useTranslation("sys.total")
    const formPassengersLabel = useTranslation("form.passengers.label")

    return (
        <>
            {!route.type.isPrivate && (
                <>
                    <GroupPrices
                        route={route}
                    />
                    <hr/>
                </>
            )}
            <Row justify className="gb--emphasize-default">
                <span>
                    {`${totalLabel} (${passengers} ${formPassengersLabel})*`}
                </span>
                <PriceWithCurrency
                    linebreak={false}
                    price={totalPrice}
                />
            </Row>
            <div>
                <span className="gb--emphasize-default">*</span>
                    <Translation translationKey="sys.prices_calculated"/>
                    <EuroConversionNotice
                        price={totalPrice}
                    />
            </div>
        </>
    )
}

export default PriceDetails;